module.exports = __webpack_public_path__ + "img/menu.db7986c7.svg";